<div class="container">
    <div class="card">
        <div class="card-header">
            <div class="col-12 text-center">
                <h5 class="card-title ">
                    Panel de administración - {{rol}}
                </h5>
            </div>
        </div>

        <div class="card-body">
            <div class="row">
                <ul class="btn-group-org">
                    <span *ngFor="let p of result">
                        <li class="btn-org" routerLink="{{p.modulo}}" routerLinkActive="active">{{p.menu}}</li>
                    </span>
                </ul>
            </div>
            <div class="container-fluid">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>